import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LibConfig, LibConfigService } from '../config/environment.config';
import { BehaviorSubject } from 'rxjs';
import { QuickCommentForm } from '../models/quickComment-inteface';

@Injectable({
  providedIn: 'root'
})
export class ChecksService {

  private authHeaderOptions: any;

  private libConfig: LibConfig;

  private checkListSubject: BehaviorSubject<string> = new BehaviorSubject('');
  checkListSubject$ = this.checkListSubject.asObservable();

  constructor(private http: HttpClient, @Inject(LibConfigService) config: LibConfig  ) {
    this.libConfig = config;
  }

  setHeader(isAuth: boolean) {
    const headers: any = {};
    if (isAuth) {
      headers.Authorization = 'Bearer ' + localStorage.getItem('access_token');
    }
    headers['Content-Type'] = 'application/json';
    headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    headers['Pragma'] = 'no-cache';
    headers['Pragma-Directive'] = 'no-cache';
    headers['Cache-Directive'] = 'no-cache';
    headers['max-age'] = '0';
    headers['expires'] = '0';
    headers['Accept-Language'] = navigator.language;
    this.authHeaderOptions = { headers: new HttpHeaders(headers) };
  }

  getApi(url: string, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.get(`${this.libConfig.api_url}${url}`, this.authHeaderOptions);
  }

  postApi(url: string, postValue: any, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.post(`${this.libConfig.api_url}${url}`, postValue, this.authHeaderOptions);
  }

  deleteApi(url: string, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.delete(`${this.libConfig.api_url}${url}`, this.authHeaderOptions);
  }

  getApiHartmann(url: string, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.get(`${this.libConfig.apiHartmannUrl}${url}`, this.authHeaderOptions);
  }

  getChecks(userId: number, institutionId: number, page: number, filterType: string) {
    //const url = "Checks/" + userId + "/" + institutionId+ "/" + page;
    const url = "GetChecksWithWards/" + userId + "/" + institutionId+ "/" + page + "/" + filterType;
    return this.getApi(url, true);
  }

  getChecksWithoutPagination(userId: number, institutionId: number) {
    const url = "Checks/" + userId + "/" + institutionId;
    return this.getApi(url, true);
  }

  getChecksById(checkId: string) {
    return this.getApi("Checks/" + checkId, true);
  }

  postCheck(data: any) {
    return this.postApi('Checks', data, true);
  }

  deleteCheck(id: string) {
    return this.deleteApi("Checks/"+id, true);
  }

  completeCheck(id: string) {
    const url = "Checks/" +id + '/complete';
    return this.postApi(url, null, true);
  }

  getWardsAndDepartments(institutionId: number) {
    // [ER:17/11/2023] in a future it will be a changed por our api
    const url = 'SOPEvaluation/GetWardsAndDepartments/'+institutionId;
    return this.getApiHartmann(url, true);
  }

  getInstitutionDetails(institutionId: number) {
    const url = 'ManageInstitution/GetInstituionDetails/'+institutionId;
    return this.getApiHartmann(url, true);
  }

  updateInternalCheckList() {
    this.checkListSubject.next('update');
  }

  updateIsFirstSAMessageShown(checkId: string) {
    const url = 'Checks/' + checkId + '/isFirstSAMessageShown';
    return this.postApi(url, null, true);
  }

  hasModifiedChecks(userId: number, institutionId: number) {
    const url = "Checks/HasModifiedChecks/" + userId + "/" + institutionId;
    return this.getApi(url, true);
  }

  getPredefinedQuickComments() {
    const url = `PredefinedQuickComment`;
    return this.getApi(url, true);
  }

  addPredefinedCommentsToInstitution(institutionId: number, countryID: number) {
    const url = `predefinedQuickComment/${institutionId}/${countryID}`;
    return this.postApi(url, null, true);
  }

  addCountryTemplatesToInstitution(institutionId: number, countryID: number) {
    const url = `questionnaires/assign/${institutionId}/${countryID}`;
    return this.postApi(url, null, true);
  }
  
  getPredefinedQuickCommentsByCountry(countryId: number) {
    const url = `PredefinedQuickComment/${countryId}`;
    return this.getApi(url, true);
  }

  postCreateQuickComment(quickComment: QuickCommentForm) {
    const url = `QuickComment`;
    return this.postApi(url, quickComment, true);
  }

  postCreateQuickCommentOnInstitution(quickComments: QuickCommentForm[]) {
    const url = `quickcomments/institution`;
    return this.postApi(url, quickComments, true);
  }

  getQuestionById(questionId: string) {
    const url = `Checks/${questionId}`;
    return this.getApi(url, true);
  }

  getQuestionTypes() {
    const url = `questionTypes`;
    return this.getApi(url, true);
  }
   
  getChecksHeader(institutionId: number) {
    const url = `Checks/GetChecksHeader/${institutionId}`;
    return this.getApi(url, true);
  }
}
